<bootstrap-popup
	[id]="id"
	[title]="'Associer l\'acc&egrave;s &agrave; des arr&ecirc;ts machines'"
	[windowCloseButton]="true"
	[displaySubject]="displaySubject"
	>
	<ng-container *ngIf="loaded && accesDatas">
		<div *ngIf="accesDatas.length > 1">
			<h3>
				Accès traités: {{ currentIndex }} / {{ accesDatas.length }}
			</h3>
			<mat-progress-bar
				 [mode]="'determinate'"
				 [value]="(currentIndex * 100 / accesDatas.length)"
				 >
			</mat-progress-bar>
			<br/>
		</div>
		<div class="panel panel-default">
			<div class="panel-heading">
				<h3>
					Acc&egrave;s <b>{{ accesDatas[currentIndex].acces.numero }}</b> 
					<ng-container *ngIf="accesDatas[currentIndex].ouvrages.length">
						{{ accesDatas[currentIndex].ouvrages.length == 1 ? ' sur l\'ouvrage ' : ' sur les ouvrages ' }} <b>{{ accesDatas[currentIndex].ouvrages[0].nom }}</b>
						<ng-container *ngIf="accesDatas[currentIndex].ouvrages.length >= 2">
							&nbsp;, <b>{{ accesDatas[currentIndex].ouvrages[1].nom }}</b>
						</ng-container>
						<ng-container *ngIf="accesDatas[currentIndex].ouvrages.length >= 3">
							&nbsp;, ...
						</ng-container>
					</ng-container>
					le {{ accesDatas[currentIndex].acces.dateDebut | localDateTimeToDate : accesDatas[currentIndex].acces.ice | date : "dd/MM/yyyy '&agrave;' HH:mm"}}
					{{ accesDatas[currentIndex].acces.dateFermeture ? ', terminé le ' : ''}} 
					{{ accesDatas[currentIndex].acces.dateFermeture | localDateTimeToDate : accesDatas[currentIndex].acces.ice | date : "dd/MM/yyyy 'à' HH:mm"}}
				</h3>
			</div>
			<div class="panel-body">
				<form class="form-horizontal">
					<acces-association-arrets
						[accesId]="accesDatas[currentIndex].acces.id"
						(commentaireArretsChange)="commentaireArrets = $event"
						(arretsAccesChange)="arretsAcces = $event"
						(onSignalementNoArrets)="signalerNoArretsFound($event)"
						[initialArretsAcces]="arretsAcces"
						>
					</acces-association-arrets>
				</form>			
			</div>
		</div>
		<div class="modal-footer">
			<div class="form-group text-center">
				<br/>
				<button type="button" class="btn default" (click)="close()">
					{{ currentIndex < accesDatas.length - 1 ? 'Annuler et passer au suivant' : 'Annuler' }}
				</button>
				<ng-container *ngIf="accesDatas && accesDatas[currentIndex].acces">
					<button [disabled]="shouldDisableButtons" type="button" class="btn btn-success" (click)="save()">
						{{ currentIndex < accesDatas.length -1 ? 'Enregistrer et passer au suivant' : "Terminer l'association" }}
					</button>
				</ng-container>
			</div>
		</div>	   	
	</ng-container>
	<ng-container *ngIf="!loaded || !accesDatas">
		Chargement...
	</ng-container>
</bootstrap-popup>